import { Routes, Route, Navigate } from 'react-router-dom'

import { useAuthMe } from '@/hooks/useAuth'
import { Loading } from '@/components/ui/Loading'
import Layout from '@/components/Layout/Layout'
import LoginPage from '@/pages/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import ProjectsPage from '@/pages/ProjectsPage'
import LedgerPage from '@/pages/LedgerPage'
import MonitorsPage from '@/pages/MonitorsPage'
import AssetsPage from '@/pages/AssetsPage'
import IncidentsPage from '@/pages/IncidentsPage'
import SettingsPage from '@/pages/SettingsPage'

export default function App() {
  const { data: auth, isLoading } = useAuthMe()

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Loading />
      </div>
    )
  }

  // Not authenticated → show login
  if (!auth?.authenticated) {
    return <LoginPage />
  }

  // Authenticated → show app
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="ledger" element={<LedgerPage />} />
        <Route path="monitors" element={<MonitorsPage />} />
        <Route path="assets" element={<AssetsPage />} />
        <Route path="incidents" element={<IncidentsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
